import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Briefcase, FileText, Users, Clock } from 'lucide-react';
import './OurRole.css';

const CALENDLY_URL = 'https://calendly.com/aventalentadvisory/o-1-visa-consultation';

function OurRole() {
  const services = [
    { icon: <Shield size={18} />, text: 'Authorized O-1 agent support (where permitted)' },
    {
      icon: <Users size={18} />,
      text: 'Coordination of project-based and multi-employer engagements',
    },
    { icon: <FileText size={18} />, text: 'Professional itinerary structuring' },
    {
      icon: <Briefcase size={18} />,
      text: 'Contract and engagement coordination with end clients',
    },
    { icon: <Clock size={18} />, text: 'Strategic advisory throughout the engagement lifecycle' },
  ];

  return (
    <section id="our-role" className="role-section">
      <div className="section-container">
        <motion.div
          className="role-grid"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="role-content">
            <h2 className="role-title">Our Role as an O-1 Agent & Advisor</h2>
            <p className="role-description">
              Aven Talent Advisory LLC acts as a professional agent and strategic advisor,
              coordinating O-1–caliber engagements while prioritizing structure, documentation, and
              credibility.
            </p>

            <a
              href={CALENDLY_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="role-cta-btn"
            >
              Schedule a consultation to discuss your engagement structure
            </a>
          </div>

          <div className="role-services">
            <div className="services-card">
              {services.map((service, index) => (
                <motion.div
                  key={index}
                  className="service-item"
                  initial={{ opacity: 0, x: 20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: index * 0.08 }}
                >
                  <div className="service-icon">{service.icon}</div>
                  <span className="service-text">{service.text}</span>
                </motion.div>
              ))}
            </div>

            <p className="role-disclaimer">
              We do not provide immigration legal advice, act as a law firm, or serve as an
              employer. Legal representation is provided by qualified immigration counsel when
              required.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}

export default OurRole;
